export default __webpack_public_path__ + "static/media/logo-dark.f0085608.png";